import {hel_vcc_notify_removed} from '../../logics/shared';

import {CKickBanApiNotification} from './CKickBanApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';

export class CKickBan {
  m_KickBanApiNotification: CKickBanApiNotification | null = null;

  // コンストラクタ
  constructor() {
    this.m_KickBanApiNotification = new CKickBanApiNotification();
  }

  /** キック処理の起動 */
  addReceivedKickEventListener(fn: (params: JsonObject) => void) {
    this.m_KickBanApiNotification?.addPosChannelEvent(fn);
  }

  /** キック処理の起動 */
  receive(params: JsonObject) {
    hel_vcc_notify_removed();
  }
}
